import { useMutation } from '@tanstack/react-query';
import restClient from '../common/api/restClient';

export const useDeleteUser = ({ id, onError, onSuccess } = {}) => {
  const prefix = process.env.REACT_APP_PROXY_PREFIX || '';
  return useMutation({
    mutationFn: async (userId) => {
      // Use userId parameter if provided, otherwise use id from options
      const targetId = userId || id;
      
      const result = await restClient({ 
        url: `${prefix}/profile`, 
        method: 'delete',
        data: targetId ? { key: targetId } : undefined
      });
      return result;
    },
    onError: (error) => {
      if (onError) {
        onError(error);
      }
    },
    onSuccess: (data) => {
      if (onSuccess) {
        onSuccess(data);
      }
    }
  });
};
